import React, { useState } from 'react';
import { AdminCreateLoan } from './AdminCreateLoan';
import { Box, Heading, Tabs, TabList, TabItem, TabPanel, Button } from '@razorpay/blade/components';
import { ActiveLoansTable } from './components/ActiveLoansTable';
import { ClosedLoansTable } from './components/ClosedLoansTable';
import { PendingDisbursementsView } from './components/PendingDisbursementsView';
import { useLoanData } from './useLoanData';
import { LOAN_STATUS } from './constants';
import { useFilters } from 'hooks/useFilters';

const FILTERS_MAP = {
  status: 'status',
} as const;

const TAB_STATUS: Record<string, number> = {
  active: LOAN_STATUS.ACTIVE,
  closed: LOAN_STATUS.CLOSED,
};

const statusToTab = (status: string | undefined): string => {
  if (status === String(LOAN_STATUS.CLOSED)) return 'closed';
  return 'active';
};

export const LoansAndAdvances = () => {
  const [showDisbursements, setShowDisbursements] = useState(false);
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const { currentFilters, applyFilter } = useFilters({
    filtersMap: FILTERS_MAP,
  });

  const activeTab = statusToTab(currentFilters.status);

  const { data: approvedData } = useLoanData(LOAN_STATUS.APPROVED);
  const approvedCount = approvedData?.total ?? 0;

  const handleTabChange = (value: string) => {
    applyFilter('status', String(TAB_STATUS[value] ?? LOAN_STATUS.ACTIVE));
  };

  if (showDisbursements) {
    return <PendingDisbursementsView onBack={() => setShowDisbursements(false)} />;
  }

  return (
    <>
      <Box>
        <Box padding="spacing.8">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            marginBottom="spacing.5">
            <Heading size="large" weight="semibold">
              Loans & Advances
            </Heading>
            <Box display="flex" gap="spacing.3">
              {approvedCount ? (
                <Button variant="secondary" onClick={() => setShowDisbursements(true)}>
                  {`Pending Disbursements (${approvedCount})`}
                </Button>
              ) : null}
              <Button onClick={() => setIsCreateOpen(true)}>+ Create</Button>
            </Box>
          </Box>

          <Tabs value={activeTab} onChange={handleTabChange}>
            <TabList>
              <TabItem value="active">Active</TabItem>
              <TabItem value="closed">Closed</TabItem>
            </TabList>
            <TabPanel value="active">
              <Box paddingTop="spacing.7">{activeTab === 'active' && <ActiveLoansTable />}</Box>
            </TabPanel>
            <TabPanel value="closed">
              <Box paddingTop="spacing.7">{activeTab === 'closed' && <ClosedLoansTable />}</Box>
            </TabPanel>
          </Tabs>
        </Box>
      </Box>

      <AdminCreateLoan isOpen={isCreateOpen} onClose={() => setIsCreateOpen(false)} />
    </>
  );
};

export default LoansAndAdvances;
